import { FC } from 'react'
import styles from 'components/features/pfm/InputToggle/InputToggle.styl'
import cn from 'classnames'

type InputToggleProps = {
  isEnabled: boolean
}

export const InputToggle: FC<InputToggleProps> = (props) => {
  const { isEnabled } = props

  return (
    <div className={ cn(styles.inputToggle, isEnabled && styles.enabled) } />
  )
}
